import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './_layout/private-layout/private-layout.component';
import { AuthGuard } from './_guards/auth.guard';
import { RegisterComponent } from './register';
import { LoginComponent } from './login';
import { Login2Component } from './login2';
import { ChangelogComponent } from './changelog/changelog.component';

const appRoutes: Routes = [
  // Public layout
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: 'register', component: RegisterComponent },
      { path: 'login', component: LoginComponent },
      { path: 'login2', component: Login2Component },
      { path: '', component: LoginComponent }
    ]
  },
  // Private layout
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      { path: 'logout', component: LoginComponent, canActivate: [AuthGuard] },
      { path: 'changelog', component: ChangelogComponent, canActivate: [AuthGuard] },
      { path: 'dashboard', loadChildren: () => import('../app/content/dashboard/dashboard.module').then(m => m.DashboardModule)
      , canActivate: [AuthGuard] },
      { path: 'user', loadChildren: () => import('../app/content/user/user.module').then(m => m.UserModule)
      , canActivate: [AuthGuard] },
      { path: 'a/users', loadChildren: () => import('../app/content/user-management/user-management.module').then(m => m.UserManagementModule)
      , canActivate: [AuthGuard] },
      { path: 'a/management', loadChildren: () => import('../app/content/audience/audience-management.module').then(m => m.AudienceManagementModule)
      , canActivate: [AuthGuard] },
      { path: 'a/roles', loadChildren: () => import('../app/content/role-management/role-management.module').then(m => m.RoleManagementModule)
      , canActivate: [AuthGuard] },
      { path: 'h/pending', loadChildren: () => import('../app/content/pending-transaction/pending-transaction.module').then(m => m.PendingTransactionModule)
      , canActivate: [AuthGuard] },
      { path: 'h/confirm', loadChildren: () => import('../app/content/confirmed-transaction/confirmed-transaction.module').then(m => m.ConfirmedTransactionModule)
      , canActivate: [AuthGuard] },
      { path: 'h/checkout', loadChildren: () => import('../app/content/checkout/checkout.module').then(m => m.CheckoutModule)
      , canActivate: [AuthGuard] },
      { path: 'h/master', loadChildren: () => import('../app/content/master/master.module').then(m => m.MasterModule)
      , canActivate: [AuthGuard] },
      { path: 'h/operation', loadChildren: () => import('../app/content/operations/operations.module').then(m => m.OperationsModule)
      , canActivate: [AuthGuard] },
      { path: 'h/reports', loadChildren: () => import('../app/content/reports/reports.module').then(m => m.ReportsModule)
      , canActivate: [AuthGuard] },
      { path: 'h/subscription', loadChildren: () => import('../app/content/subscription/subscription.module').then(m => m.SubscriptionModule)
      , canActivate: [AuthGuard] },
      { path: 'h/user', loadChildren: () => import('../app/content/hote-user-registration/hote-user-registration.module').then(m => m.HoteUserRegistrationModule)
      , canActivate: [AuthGuard] },
      // { path: 'h/dashboard', loadChildren: () => import('../app/content/hotel-dashboard/hotel-dashboard.module').then(m => m.HotelDashboardModule)
      // , canActivate: [AuthGuard] },
      //corporate
      { path: 'c/room', loadChildren: () => import('../app/content/room-booking/room-booking.module').then(m => m.RoomBookingModule)
      , canActivate: [AuthGuard] },
      { path: 'c/group', loadChildren: () => import('../app/content/group-booking/group-booking.module').then(m => m.GroupBookingModule)
      , canActivate: [AuthGuard] },
      { path: 'c/banquet', loadChildren: () => import('../app/content/banquet-booking/banquet-booking.module').then(m => m.BanquetBookingModule)
      , canActivate: [AuthGuard] },
      { path: 'c/tripsummary', loadChildren: () => import('../app/content/trip-summary/trip-summary.module').then(m =>m.TripSummaryModule)
      , canActivate: [AuthGuard] },
      { path: 'c/corporate', loadChildren: () => import('../app/content/corp-masters/corp-masters.module').then(m =>m.CorpMastersModule)
      , canActivate: [AuthGuard] },
      { path: 'c/operations', loadChildren: () => import('../app/content/corp-operations/corp-operations.module').then(m =>m.CorpOperationsModule)
      , canActivate: [AuthGuard] },
      { path: 'c/reports', loadChildren: () => import('../app/content/corp-reports/corp-reports.module').then(m =>m.CorpReportsModule)
      , canActivate: [AuthGuard] },
      { path: 'c/subscription', loadChildren: () => import('../app/content/corp-subscriptions/corp-subscriptions.module').then(m =>m.CorpSubscriptionsModule)
      , canActivate: [AuthGuard] },
      { path: 'c/user', loadChildren: () => import('../app/content/corp-user-registration/corp-user-registration.module').then(m =>m.CorpUserRegistrationModule)
      , canActivate: [AuthGuard] },
      { path: 'c/approver', loadChildren: () => import('../app/content/corp-approver/corp-approver.module').then(m =>m.CorpApproverModule)
      , canActivate: [AuthGuard] },
      { path: 'c/employee', loadChildren: () => import('../app/content/corp-employee/corp-employee.module').then(m =>m.CorpEmployeeModule)
      , canActivate: [AuthGuard] },
      { path: 'c/browsehotel', loadChildren: () => import('../app/content/browse-hotels/browse-hotels.module').then(m =>m.BrowseHotelsModule)
      , canActivate: [AuthGuard] },
      { path: 'c/budget-management', loadChildren: () => import('../app/content/budget-management/budget-management.module').then(m =>m.BudgetManagementModule)
      , canActivate: [AuthGuard] },
      { path: 'c/expense-management', loadChildren: () => import('../app/content/corp-employee/corp-employee.module').then(m =>m.CorpEmployeeModule)
      , canActivate: [AuthGuard] },
      // { path: 'c/tdadmin-dashboard', loadChildren: () => import('../app/content/travel-admin-dashboard/travel-admin-dashboard.module').then(m =>m.TravelAdminDashboardModule)
      // , canActivate: [AuthGuard] },
      // { path: 'c/tduser-dashboard', loadChildren: () => import('../app/content/travel-user-dashboard/travel-user-dashboard.module').then(m =>m.TravelUserDashboardModule)
      // , canActivate: [AuthGuard] },
      // src\app\content\corp-employee\corp-employee.module.ts
      { path: 'a/operations', loadChildren: () => import('../app/content/admin-operations/admin-operations.module').then(m =>m.AdminOperationsModule)
      , canActivate: [AuthGuard] },
      { path: 'a/reports', loadChildren: () => import('../app/content/admin-reports/admin-reports.module').then(m =>m.AdminReportsModule)
      , canActivate: [AuthGuard] },

      { path: 'a/client-reports', loadChildren: () => import('../app/content/admin-client-based-reports/admin-client-based-reports.module').then(m =>m.AdminClientBasedReportsModule)
      , canActivate: [AuthGuard] },

      { path: 'a/subscription', loadChildren: () => import('../app/content/admin-subscription/admin-subscription.module').then(m =>m.AdminSubscriptionModule)
      , canActivate: [AuthGuard] },

      { path: 'faq', loadChildren: () => import('../app/content/faq/faq.module').then(m =>m.FaqModule)
      , canActivate: [AuthGuard] },

    ],
  },
  // otherwise redirect to home
  { path: '**', redirectTo: 'dashboard' }
];

export const routing = RouterModule.forRoot(appRoutes, { scrollOffset: [0, 0], scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy', preloadingStrategy: PreloadAllModules });
